// Title row for a dashboard chart card: the h3 title + an optional info tooltip. Consolidates
// the repeated `<h3 className="text-base font-medium …">` markup used by every chart card. The
// info icon appears only when `tooltip` is provided.
import React, { ReactNode } from 'react';
import DashboardInfoTooltip from './DashboardInfoTooltip.tsx';

interface DashboardChartTitleProps {
  title: ReactNode;
  tooltip?: ReactNode;
  // Bottom-margin override (some cards sit tighter above a select); defaults to mb-4.
  className?: string;
}

const DashboardChartTitle: React.FC<DashboardChartTitleProps> = ({ title, tooltip, className = 'mb-4' }) => (
  <div className={`flex items-center gap-2 ${className}`}>
    <h3 className="text-base font-medium text-content-primary">{title}</h3>
    <DashboardInfoTooltip content={tooltip} />
  </div>
);

export default DashboardChartTitle;